export default "__VITE_ASSET__sg4PQ63x__"